import system from '../views/system'

export default {
  path: 'system',
  component: system,
  redirect: '/system/user',
  name: 'System',
  meta: {
    title: '商家管理'
  },
  children: [
    {
      path: '/system/user',
      component: () => import('@/views/system/User'),
      name: 'User',
      meta: { title: '店铺列表' }
    },
    {
      path: '/system/menu',
      component: () => import('@/views/system/Menu'),
      name: 'Menu',
      meta: { title: '证件审核' }
    },
    {
      path: '/system/role',
      component: () => import('@/views/system/Role'),
      name: 'Role',
      meta: { title: '订单列表' }
    },
    {
      path: '/system/wuliu',
      component: () => import('@/views/system/Wuliu'),
      name: 'Role',
      meta: { title: '物流列表' }
    },
    {
      path: '/system/dept',
      component: () => import('@/views/system/Dept'),
      name: 'Dept',
      meta: { title: '添加店铺' }
    },
    {
      path: '/system/notice',
      component: () => import('@/views/system/Notice'),
      name: 'Notice',
      meta: { title: '轮播图管理' }
    }
  ]
}
